import OneLoginIcon from 'components/core/icons/onelogin.svg'
import Image from 'components/core/image'
import React from 'react'

const OneLogin = (): React.ReactElement => {
    return <Image src={OneLoginIcon.src} height={24} width={24} />
}

export default OneLogin
